// Enum representing roughly boxes available in a drop of location
export enum BoxAvailability {
    None = 'None',
    Low = 'Low',
    Medium = 'Medium',
    High = 'High',
}
